var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity-infos-logs-list',{attrs:{"items":_vm.items,"options":_vm.options,"total-items":_vm.meta.total_count,"pending":_vm.pending},on:{"update:options":_vm.updateOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }